// extracted by mini-css-extract-plugin
export var label = "_bm-5";
export var slideContainer = "_bm-0";
export var slider = "_bm-1";
export var sliderLg = "_bm-4";
export var sliderMd = "_bm-3";
export var sliderSm = "_bm-2";